import React, { useCallback } from 'react';
import Button from '../../Button';
import { useAuth } from '../../../hooks/auth';
import { SignHeadText } from '../../../styles/globalStyled';

const RecoverPassword: React.FC = () => {
  const { user, loading, handleRecoverKey } = useAuth();

  const sendEmail = useCallback(() => {
    handleRecoverKey();
  }, []);

  return (
    <>
      <SignHeadText>
        <label>Esqueceu sua senha?</label>
        <p>Enviaremos para {user.email} instruções para recuperá-la.</p>
      </SignHeadText>
      <Button title="Enviar Email" classType="big fat orange center topspace" loading={loading} onClick={sendEmail} />
    </>
  );
};

export default RecoverPassword;
